<template>
  <v-container fluid class="grey lighten-3">

    <v-card class="mb-5">

        <v-tabs v-model="tab" @change="tabChanged">
          <v-tab v-for="item in items" :key="item">{{ item }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <CloneCampaign v-if="tab == 0"></CloneCampaign>
          </v-tab-item>
          <v-tab-item>
            <MultiplyAdGroups v-if="tab == 1"></MultiplyAdGroups>
          </v-tab-item>
        </v-tabs-items>

    </v-card>

  </v-container>
</template>

<script>
export default {
  name: 'CloningTool',

  data () {
    return {
      tab: null,
      items: ['Clone a campaign', 'Multiply ad groups'],
      lsTab: 'cloningTool_tab',
    }
  },

  components: {
    CloneCampaign: () => import('@/components/cloningTool/CloneCampaign.vue'),
    MultiplyAdGroups: () => import('@/components/cloningTool/MultiplyAdGroups.vue')
  },

  methods: {
    tabChanged () {
      localStorage.setItem(this.lsTab, JSON.stringify(this.tab))
    },
  },

  created: function () {
    if (localStorage.getItem(this.lsTab)) {
      this.tab = JSON.parse(localStorage.getItem(this.lsTab))
    }
  },
}
</script>

<style scoped>
</style>